import { useSeo } from "@/hooks/useSeo";
import { FAQS } from "@/data/site";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";

export default function FAQ() {
  useSeo(
    "FAQ | CNC Machining Questions | Edgeworks Manufacturing",
    "Answers to common questions about CNC machining quotes, file types, one-off jobs, production runs, materials, lead times, privacy, and service area in Eastern Ontario."
  );

  return (
    <div>
      <section className="border-b border-neutral-800 bg-neutral-900">
        <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-20">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-orange-500">FAQ</p>
          <h1 className="mt-3 font-heading text-4xl font-black tracking-tighter text-white sm:text-5xl">
            Frequently Asked Questions
          </h1>
        </div>
      </section>

      <section className="mx-auto max-w-3xl px-4 py-16 sm:px-6 lg:px-8 lg:py-20">
        <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="border-b border-neutral-800">
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="py-5 text-left font-heading text-lg font-semibold text-white hover:text-orange-500 hover:no-underline"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="pb-5 text-base leading-relaxed text-neutral-400">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </section>
    </div>
  );
}
